<template>
  <div
v-click-outside="hidePop"
v-tooltip="{
      content: 'Share',
      show:showPop,
      placement:'bottom',
      trigger:'manual'
    }"
:class="showShare?'active':''"
    @mouseenter="showPop = !showShare"
    @mouseleave="showPop = false"
    @click="toggleShare"
    class="share"
>
    <div v-show="true" class="share-popup">
      <div v-if="status ==='loading'" class="loading-mask">
        <div class="loadingImg" />
      </div>
      <div class="share_btnGroup">
        <div @click="jobActionHandle('facebook')" class="share_button facebook" rel="preload" />
        <div @click="jobActionHandle('linkedin')" class="share_button linkedin" rel="preload" />
        <div @click="jobActionHandle('line')" class="share_button line" rel="preload" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  props: {
    url: {
      default: null,
      type: String
    },
    id: {
      default: null,
      type: String
    }
  },
  data: function () {
    return {
      isValid: false,
      showShare: false,
      showPop: false,
      error: false,
      status: 'default'
    }
  },
  methods: {
    cp: function(status) {
      console.log(status)
      this.stauts = status
      if (status === 'sent' || status === 'close') {
        this.showShare = false
      }
    },
    hidePop: function () {
      this.showShare = false
    },
    jobActionHandle: function (type) {
      const jobTitle = encodeURIComponent(document.title)
      // const jobId = $('#jobId').val()
      const jobLink = encodeURIComponent(this.url)
      switch (type) {
        case 'facebook':
          const faceLink = 'http://www.facebook.com/sharer.php?u=' + jobLink + '&t=' + encodeURIComponent(jobTitle)
          console.log(faceLink)
          window.open(faceLink, '_blank', 'location=0,status=0,scrollbars=1,resizable=1,width=620,height=548')
          break
        case 'linkedin':
          // var twitterLink="http://twitter.com/home?status=Currently reading "+jobLink;

          const linkedinLink = 'http://www.linkedin.com/shareArticle?mini=true&url=' + jobLink + '&title=' + jobTitle + '&summary=&source=jiujik.com'
          window.open(linkedinLink, '_blank', 'location=0,status=0,scrollbars=1,resizable=1,width=820,height=548')
          break
        case 'weibo':
          const weiboLink = 'http://v.t.sina.com.cn/share/share.php?url=' + jobLink + '&title=' + jobTitle
          window.open(weiboLink, '_blank', 'location=0,status=0,scrollbars=1,resizable=1,width=595,height=548')
          break
        case 'google':
          const googleLink = 'http://www.google.com/reader/link?url=' + jobLink + '&title=' + jobTitle
          window.open(googleLink, '_blank', 'location=0,status=0,scrollbars=1,resizable=1,width=595,height=548')
          break
        case 'line':
          const linelink = 'https://social-plugins.line.me/lineit/share?url=' + jobLink + '&title=' + jobTitle
          window.open(linelink, '_blank', 'location=0,status=0,scrollbars=1,resizable=1,width=595,height=548')
          break
          // case 'recommend':
          //   window.open(generateUrl('search/recommend/' + jobId), '_self')

        //   break
        case 'print':
          window.print()
          break
      }
    },
    toggleEmail: function () {
      document.querySelector('.email-form').classList.toggle('active')
    },
    toggleShare: function(event) {
      if (event && event.target) {
        const { target } = event
        const checkNav = target.className === 'share active' || target.parentElement.className === 'share icon'
        this.showShare = checkNav ? !this.showShare : true
      } else {
        this.showShare = true
      }
    }
  }
}

</script>
<style lang="scss">
  .share {
    height: 100%;

    .share-popup {
      cursor: default;
      display: none;
      position: absolute;
      right: -50px;
      background: rgba(255, 255, 255, 1) 0% 0% no-repeat padding-box;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.42);
      padding: 10px 15px;
      border-radius: 30px;
      min-width: 180px;
      text-align: center;
      .share_btnGroup{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-content: center;
        &::before{
          content: '';
          width: 15px;
          height: 15px;
          position: absolute;
          top: -8px;
          right: 58px;
          background: #fff;
          z-index: 999;
          display: flex;
          /* border: 1px solid #000; */
          box-shadow: 0px 0px 4px rgba(0,0,0,0.42);
          z-index: -1;
          transform: rotate(45deg);
        }
        &::after{
          content: '';
          background: #fff;
          width: 15px;
          height: 15px;
          position: absolute;
          top: -8px;
          right: 58px;
          z-index: 1;
          transform: rotate(45deg);
        }
      }
      .loading-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.1);
        z-index: 10;

        div.loadingImg {
          height: 50px;
          width: 50px;
          background-image: url(/asset/image/icon/ef-loading.png);
          background-size: contain;
          position: relative;
          top: 50%;
          left: 50%;
          -webkit-animation: rotation 2s infinite linear;
          @-webkit-keyframes rotation {
            from {
              -webkit-transform: translate(-50%, -50%) rotate(0deg);
            }

            to {
              -webkit-transform: translate(-50%, -50%) rotate(359deg);
            }
          }
        }
      }

      .triangle {
        position: absolute;
        top: -15px;
        right: 20px;
        width: 0;
        height: 0;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 20px solid #E4E7F2;
      }

      .share_button {
        cursor: pointer;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: inline-block;
        top: 50%;
        position: relative;
        margin: 0 10px;
        background-position: center center;
        background-size: contain;
        &.email {
          background-image: url(/asset/image/icon/ef-mail.png)
        }

        &.print {
          background-image: url(/asset/image/icon/ef-print.png)
        }

        &.facebook {
          background-image: url(/asset/image/icon/sh-fb.svg)
        }

        &.linkedin {
          background-image: url(/asset/image/icon/sh-linkedin.svg)
        }
        &.line {
          background-image: url(/asset/image/icon/sh-line.svg)
        }
      }
    }

    &.active {
      .share-popup {
        top: 50px;
        display: block;
      }
    }
  }

</style>
